import { type SignalType, signalTypeMap } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type { Translatable } from "app/pages/sales-intelligence/types";

import type ModifySignalViewModel from "../../../models/view/signal-modal/ModifySignalViewModel";
import signalsI18nKeys from "../../../utils/i18n";
import SignalManagementBase from "../../shared/SignalManagementBase/SignalManagementBase";
import type { SignalManagementBaseProps } from "../../shared/SignalManagementBase/SignalManagementBase";
import ModalHeaderContent from "../SignalsModal/ModalHeaderContent/ModalHeaderContent";

const ADD_SIGNAL_DESCRIPTION_BY_TYPE: Partial<Record<SignalType, Readonly<Translatable>>> = {
    [signalTypeMap.ecommerce]: { key: signalsI18nKeys.addSignal.description(signalTypeMap.ecommerce) },
};

export type CreateSignalModalProps = Omit<SignalManagementBaseProps, "headerContent"> & {
    viewModel: Readonly<ModifySignalViewModel>;
};

const CreateSignalModal = (props: CreateSignalModalProps) => {
    const { isOpen, viewModel, children, onReturn, onClose } = props;

    const selectedSignalType = viewModel.initiallySelectedType;
    const titleTranslatable = {
        key: signalsI18nKeys.addSignal.cta(selectedSignalType),
    };
    const descriptionTranslatable: Readonly<Translatable> = ADD_SIGNAL_DESCRIPTION_BY_TYPE[selectedSignalType] ?? {
        key: signalsI18nKeys.addSignal.descriptionFallback,
    };

    return (
        <SignalManagementBase
            isOpen={isOpen}
            headerContent={
                <ModalHeaderContent
                    title={titleTranslatable}
                    description={descriptionTranslatable}
                />
            }
            onReturn={onReturn}
            onClose={onClose}
        >
            {children}
        </SignalManagementBase>
    );
};

export default CreateSignalModal;
